import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";

const parentBreadCrumbs = [{ title: "menu_sidebar_personal_accident" }, { title: "menu_sidebar_health_orders", link: "/personal-accident/orders" }];

const PersonalAccidentOrderListing = Loadable({
  loader: () => import("container/personalAccident/order/listing"),
  loading() {
    return <Loader />;
  }
});

const PersonalAccidentOrder = Loadable({
  loader: () => import("container/personalAccident/order"),
  loading() {
    return <Loader />;
  }
});

export const PersonalAccidentOrderRoutes: IRoute[] = [
  {
    path: "/personal-accident/orders",
    element: <PersonalAccidentOrderListing />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  },
  {
    path: "/personal-accident/orders/details/:id?",
    element: <PersonalAccidentOrder />,
    handle: {
      crumbs: [...parentBreadCrumbs]
    }
  }
];
